<template>
  <!-- 原型 HTML 还原正文；顶/底由门户 PortalNavbar + PortalFooter 提供 -->
  <div class="sol-is-home">
    <!-- ===== Hero ===== -->
    <section class="hero" id="hero">
      <div class="container">
        <div class="hero-grid">
          <div class="hero-content reveal active">
            <div class="hero-badge">
              <span class="dot"></span>
              <span>已服务 8,000+ 家装企业 · 30,000+ 设计师与门店</span>
            </div>
            <h1>家装家居SaaS解决方案<br><span class="highlight">打通设计到交付</span>，一站式智慧经营</h1>
            <p class="hero-sub">整合门店、商城、云设计、供应链、施工、会员、数据全链路，助力家装家居企业实现数字化转型。从线上获客到全屋定制，从供应链协同到施工交付，一个平台搞定全流程。</p>
            <div class="hero-tags">
              <span>智慧门店</span>
              <span>全屋定制</span>
              <span>云设计</span>
              <span>供应链协同</span>
              <span>家装数字化</span>
            </div>
            <div class="hero-cta">
              <button class="btn btn-primary btn-lg" @click="scrollToSection('cta')"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>立即预约演示</button>
            </div>
            <div class="hero-trust">
              <div class="hero-trust-item">
                <div>
                  <div class="hero-trust-num">8,000+</div>
                  <div class="hero-trust-label">服务装企</div>
                </div>
              </div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item">
                <div>
                  <div class="hero-trust-num">99.9%</div>
                  <div class="hero-trust-label">系统可用性</div>
                </div>
              </div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item">
                <div>
                  <div class="hero-trust-num">7×24</div>
                  <div class="hero-trust-label">专属服务支持</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Dashboard Mockup -->
          <div class="hero-visual reveal reveal-delay-1 active">
            <div class="dash-mock">
              <div class="dash-bar">
                <div class="dots"><span></span><span></span><span></span></div>
                <div class="url">app.homecloud.com/dashboard</div>
              </div>
              <div class="dash-body">
                <div class="dash-side">
                  <div class="icon-item active"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7L9 18l-5-5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 22c0-4 4-7 8-7s8 3 8 7"/></svg></div>
                </div>
                <div class="dash-main">
                  <div class="dash-stats">
                    <div class="dash-stat">
                      <div class="dash-stat-label">今日签单额</div>
                      <div class="dash-stat-val">¥1.28M</div>
                      <div class="dash-stat-trend up">↑ 23.5%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">量房预约</div>
                      <div class="dash-stat-val">86</div>
                      <div class="dash-stat-trend up">↑ 18.2%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">新增业主</div>
                      <div class="dash-stat-val">142</div>
                      <div class="dash-stat-trend up">↑ 42.1%</div>
                    </div>
                  </div>
                  <div class="dash-chart">
                    <div class="dash-chart-head">
                      <div class="dash-chart-title">全渠道获客趋势</div>
                      <div class="dash-chart-tag">近7日</div>
                    </div>
                    <div class="bars">
                      <div class="bar" style="height:45%"></div>
                      <div class="bar" style="height:62%"></div>
                      <div class="bar dim" style="height:38%"></div>
                      <div class="bar" style="height:75%"></div>
                      <div class="bar" style="height:55%"></div>
                      <div class="bar" style="height:88%"></div>
                      <div class="bar" style="height:95%"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dash-float dash-float-1">
              <div class="dash-float-icon green">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">设计一键出图</div>
                <div class="label">方案 · 报价 · 选材</div>
              </div>
            </div>
            <div class="dash-float dash-float-2">
              <div class="dash-float-icon blue">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">交付准时 95%+</div>
                <div class="label">施工履约</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Pain Points ===== -->
    <section class="section pain-section" id="pain">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">01 PAIN POINTS</div>
          <h2 class="section-title">行业现状与经营痛点</h2>
          <p class="section-subtitle">传统家装家居经营模式存在渠道割裂、设计低效、交付不透明等诸多难题，严重制约企业规模化发展</p>
        </div>
        <div class="pain-grid">
          <div class="pain-card reveal">
            <div class="pain-num">01</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 12a9 9 0 11-6.219-8.56"/><path d="M22 4L12 14.01l-3-3"/></svg>
            </div>
            <h3 class="pain-title">渠道割裂脱节</h3>
            <p class="pain-desc">线下门店、天猫京东电商、微信私域、小程序商城数据互不互通，业主资源分散，无法统一精细化运营，全域流量难以沉淀。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">02</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></svg>
            </div>
            <h3 class="pain-title">设计选材效率低</h3>
            <p class="pain-desc">设计师重复画图、方案素材分散，业主等待周期长、沟通成本高，方案迭代慢，成交流失率高。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">03</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3 class="pain-title">施工进度不透明</h3>
            <p class="pain-desc">工期、节点、验收信息滞后，业主无法实时查看进度，问题发现晚，投诉与纠纷频发，售后压力大。</p>
          </div>
          <div class="pain-card reveal">
            <div class="pain-num">04</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg>
            </div>
            <h3 class="pain-title">供应链协同混乱</h3>
            <p class="pain-desc">多品牌多品类共用库存无统一管控，超卖、漏单、积压问题频发，人工盘点、对账效率低下，数据误差率高。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">05</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            </div>
            <h3 class="pain-title">客户流失严重</h3>
            <p class="pain-desc">家装决策周期长，缺乏业主分层与跟进机制，意向客户大量流失，老客转介绍难以激活，获客成本居高不下。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">06</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            </div>
            <h3 class="pain-title">运营成本偏高</h3>
            <p class="pain-desc">依赖人工录单、报价、对账、跟进，人力成本高昂，工作效率低，业主响应速度慢，极易出现人为失误。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Solution Overview ===== -->
    <section class="section solution-section" id="solution">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">02 SOLUTION OVERVIEW</div>
          <h2 class="section-title">解决方案总览</h2>
          <p class="section-subtitle">专为大家装公司、全屋定制、家居建材门店打造的一体化SaaS数字化管理平台，全方位解决行业经营痛点</p>
        </div>
        <div class="solution-grid">
          <div class="solution-card reveal">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg>
            </div>
            <h3>方案简介</h3>
            <p>整合设计、门店、商城、供应链、施工、会员、营销、数据全链路能力，打破系统壁垒，实现家装全流程一体化数字经营。</p>
          </div>
          <div class="solution-card reveal reveal-delay-1">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/><path d="M2 12h20"/></svg>
            </div>
            <h3>方案目标</h3>
            <p>实现设计营销一体化、经营数据可视化、业主运营精细化、施工交付透明化，助力装企提质增效、稳健增长。</p>
          </div>
          <div class="solution-card reveal reveal-delay-2">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3>适用对象</h3>
            <p>家装公司、全屋定制品牌、家居建材门店、设计工作室、软装搭配机构及连锁装企总部。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Core Functions ===== -->
    <section class="section func-section" id="features">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">03 CORE MODULES</div>
          <h2 class="section-title">核心功能模块</h2>
          <p class="section-subtitle">全链路数字化功能矩阵，覆盖家装家居经营全场景，一站式解决经营管理难题</p>
        </div>
        <div class="func-grid">
          <div class="func-card reveal">
            <div class="func-card-num">01</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg></div>
              <h3>全渠道门店与获客体系</h3>
              <p>快速搭建小程序、H5、公众号门店，对接天猫、京东、抖音等第三方平台，统一管理商品、线索、活动，实现多渠道同步获客、统一跟进。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">02</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg></div>
              <h3>云端设计与方案库</h3>
              <p>内置户型库、素材库与渲染能力，设计师在线出图、快速改方案，业主可视化看效果，缩短决策周期、显著提升成交转化。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">03</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></svg></div>
              <h3>全屋定制与产品选型</h3>
              <p>打通定制与成品供应链，支持套餐、个性化配置与一键报价，业主在线选品、看预算，方案即所见即所得，减少增项纠纷。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">04</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg></div>
              <h3>供应链与进销存管理</h3>
              <p>覆盖采购、入库、出库、调拨全流程数字化，实时同步多渠道库存，智能预警缺货、积压，彻底杜绝超卖与库存混乱。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">05</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg></div>
              <h3>业主私域精细化运营</h3>
              <p>统一业主档案，支持标签、跟进、积分、优惠券等功能，搭配精准群发、复购与转介绍提醒，长周期培育客户资产。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">06</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg></div>
              <h3>施工交付管理</h3>
              <p>工期排程、节点验收、工地直播与售后工单一体化，业主实时查看进度，透明交付、降低纠纷，沉淀口碑与转介绍。</p>
            </div>
          </div>
          <div class="func-card reveal" style="grid-column:span 2">
            <div class="func-card-num">07</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 10h20"/><circle cx="8" cy="15" r="1"/><circle cx="12" cy="15" r="1"/><circle cx="16" cy="15" r="1"/></svg></div>
              <h3>设计报价与财务一体化</h3>
              <p>方案自动生成报价单，归集全渠道收支流水，智能对账、自动生成财务报表，大幅减少人工操作，杜绝账务误差。支持多渠道收款统一管理，自动匹配订单与流水，异常账务智能预警，让财务管理从此省心高效。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Core Advantages ===== -->
    <section class="section advantage-section" id="advantage">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">04 CORE ADVANTAGES</div>
          <h2 class="section-title">方案核心优势</h2>
          <p class="section-subtitle">区别于单一功能系统，依托一体化SaaS平台优势，为家装家居企业提供轻量化、全链路、可拓展的数字化解决方案</p>
        </div>
        <div class="advantage-grid">
          <div class="advantage-card reveal">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg></div>
            <h3>一体化闭环经营</h3>
            <p>设计、门店、商城、供应链、施工、会员、数据全模块打通，单一系统完成家装全流程经营，无需对接多个软件。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg></div>
            <h3>轻量化SaaS部署</h3>
            <p>无需搭建服务器、无需复杂部署，开通即可使用，按需订阅付费，大幅降低中小装企数字化转型门槛与成本。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-2">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg></div>
            <h3>全终端适配同步</h3>
            <p>适配电脑端、手机端、平板与门店大屏多终端，数据实时同步，设计师与店员随时随地管理经营。</p>
          </div>
          <div class="advantage-card reveal">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg></div>
            <h3>高拓展可定制</h3>
            <p>支持对接主流设计软件、支付、物流、主辅材供应链等第三方平台，可根据企业需求定制功能，适配工作室到连锁装企。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7L9 18l-5-5"/></svg></div>
            <h3>简单易上手操作</h3>
            <p>可视化简洁操作界面，设计师与店员无需专业技术能力即可快速上手，配套全程售后培训与指导服务。</p>
          </div>
          <div class="advantage-card featured reveal reveal-delay-2">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg></div>
            <h3>开放生态 · 持续迭代</h3>
            <p>深度对接主流设计平台、微信、支付宝、抖音、天猫、京东、顺丰及主辅材供应链生态，功能持续迭代升级，紧跟行业趋势，确保装企始终拥有最新、最强的数字化经营能力。</p>
          </div>
        </div>

        <div class="ai-architecture">
          <h3>紫金山 AI 家装家居全域业务架构</h3>
          <p>以全域触点获客、统一经营中台、数据 AI 智能与开放生态，支撑家装家居业务从量房到交付的完整闭环。</p>
          <div class="arch-map"><div class="arch-band"><div class="arch-band-label">全域触点层<small>在任意场景连接业主</small></div><div class="arch-band-content"><div class="arch-unit"><i>商</i>品牌商城<small>小程序 / APP</small></div><div class="arch-unit"><i>店</i>智慧门店<small>体验 / 设计</small></div><div class="arch-unit"><i>播</i>内容电商<small>直播 / 短视频</small></div><div class="arch-unit"><i>社</i>私域社群<small>企微 / 社群</small></div><div class="arch-unit"><i>量</i>预约量房<small>到家 / 上门</small></div><div class="arch-unit"><i>平</i>第三方平台<small>外部渠道</small></div></div></div><div class="arch-band core"><div class="arch-band-label">家装经营中台<small>统一商品、项目与履约</small></div><div class="arch-band-content"><div class="arch-unit"><i>商</i>商品中心<small>建材 / 家具</small></div><div class="arch-unit"><i>订</i>订单中心<small>全渠道聚合</small></div><div class="arch-unit"><i>项</i>项目进度<small>施工 / 节点</small></div><div class="arch-unit"><i>供</i>供应链<small>采购 / 配送</small></div><div class="arch-unit"><i>财</i>财务对账<small>收款 / 结算</small></div><div class="arch-unit"><i>交</i>履约交付<small>安装 / 售后</small></div></div></div><div class="arch-band"><div class="arch-band-label">客户增长中台<small>沉淀会员资产与复购</small></div><div class="arch-band-content"><div class="arch-unit"><i>会</i>会员资产<small>ID / 标签</small></div><div class="arch-unit"><i>权</i>权益积分<small>储值 / 券</small></div><div class="arch-unit"><i>营</i>营销自动化<small>触达 / 归因</small></div><div class="arch-unit"><i>导</i>导购助手<small>任务 / 激励</small></div><div class="arch-unit"><i>客</i>客服与售后<small>工单 / 满意度</small></div><div class="arch-unit"><i>分</i>分销裂变<small>邀请 / 返佣</small></div></div></div><div class="arch-band ai"><div class="arch-band-label">AI 数据智能<small>用数据驱动每一个决策</small></div><div class="arch-band-content"><div class="arch-unit"><i>AI</i>智能体<small>经营问答</small></div><div class="arch-unit"><i>AI</i>数字员工<small>任务协同</small></div><div class="arch-unit"><i>像</i>用户画像<small>洞察 / 分群</small></div><div class="arch-unit"><i>预</i>经营预测<small>销量 / 需求</small></div><div class="arch-unit"><i>算</i>算法应用<small>推荐 / 定价</small></div><div class="arch-unit"><i>看</i>数据驾驶舱<small>指标 / 预警</small></div></div></div><div class="arch-band"><div class="arch-band-label">开放与安全底座<small>连接生态，守护数据</small></div><div class="arch-band-content"><div class="arch-unit"><i>API</i>开放接口<small>标准接口</small></div><div class="arch-unit"><i>ERP</i>系统集成<small>财务 / 供应链</small></div><div class="arch-unit"><i>付</i>支付与物流<small>多服务商</small></div><div class="arch-unit"><i>权</i>权限管理<small>组织 / 角色</small></div><div class="arch-unit"><i>安</i>安全合规<small>加密 / 审计</small></div><div class="arch-unit"><i>云</i>稳定运行<small>备份 / 监控</small></div></div></div></div>
          <div class="arch-map-note"><b>紫金山 AI</b><span>用一套架构打通消费者、商品、门店、数据与 AI 能力。</span></div>
        </div>

      </div>
    </section>

    <!-- ===== Application Scenarios ===== -->
    <section class="section scenario-section" id="scenario">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">05 USE CASES</div>
          <h2 class="section-title">典型应用场景</h2>
          <p class="section-subtitle">贴合家装家居全场景经营需求，全方位适配商家日常运营与拓客增收场景</p>
        </div>
        <div class="scenario-grid">
          <div class="scenario-card reveal">
            <div class="scenario-tag">场景 01</div>
            <h3>门店引流到店量房</h3>
            <p>线下门店引流沉淀私域，预约量房、线上看方案，打通门店流量长效转化链路。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <div class="scenario-tag">场景 02</div>
            <h3>线上商城选品下单</h3>
            <p>业主线上浏览全屋套餐与单品，线上下单、到店体验，全渠道订单统一管理。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <div class="scenario-tag">场景 03</div>
            <h3>全屋定制方案呈现</h3>
            <p>设计师云端出图、一键报价，业主可视化确认方案，提升成交流与客单价。</p>
          </div>
          <div class="scenario-card reveal">
            <div class="scenario-tag">场景 04</div>
            <h3>连锁装企统一管控</h3>
            <p>总部统一管控商品、价格、活动，各门店独立运营，经营数据统一汇总分析。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <div class="scenario-tag">场景 05</div>
            <h3>业主私域长效运营</h3>
            <p>长周期培育业主，分层运营、精准触达，持续提升复购、转介绍与口碑。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <div class="scenario-tag">场景 06</div>
            <h3>直播内容种草带货</h3>
            <p>对接抖音、小红书等内容平台，种草引流，线索实时回传系统并自动跟进转化。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Customer Value ===== -->
    <section class="section value-section" id="value">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">06 CUSTOMER VALUE</div>
          <h2 class="section-title">客户落地价值</h2>
          <p class="section-subtitle">量化数字化转型成果，实实在在为家装家居企业降本、增效、增收</p>
        </div>
        <div class="value-grid">
          <div class="value-card reveal">
            <div class="value-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg></div>
            <h3>运营效率大幅提升</h3>
            <p>自动化替代人工操作，报价、订单、库存、对账等核心工作效率显著提升。</p>
            <div class="value-highlight">成本降低 30%-60%</div>
          </div>
          <div class="value-card reveal reveal-delay-1">
            <div class="value-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg></div>
            <h3>整体营收稳步增长</h3>
            <p>依托全域获客与私域精细化运营，助力装企新客增长、老客复购与转介绍。</p>
            <div class="value-highlight">营收提升 20%-50%</div>
          </div>
          <div class="value-card reveal reveal-delay-2">
            <div class="value-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div>
            <h3>经营风险有效降低</h3>
            <p>精准化库存管控、透明施工与智能账务核对，减少货品积压、超卖与纠纷损耗。</p>
            <div class="value-highlight">损耗减少 40%+</div>
          </div>
          <div class="value-card reveal reveal-delay-3">
            <div class="value-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-4 0h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg></div>
            <h3>科学数据化决策</h3>
            <p>全维度经营数据可视化呈现，告别经验式经营，实现数据驱动的精准运营与战略决策。</p>
            <div class="value-highlight">决策效率 80%↑</div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Trust Section ===== -->
    <section class="trust-section" id="trust">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">07 TRUST & RECOGNITION</div>
          <h2 class="section-title">品牌信任背书</h2>
          <p class="section-subtitle">8,000+ 家装家居企业的共同选择，权威认证护航，生态合作共建数字化未来</p>
        </div>
        <div class="trust-stats reveal">
          <div class="trust-stat">
            <div class="num">8,000<span class="unit">+</span></div>
            <div class="label">服务装企</div>
          </div>
          <div class="trust-stat">
            <div class="num">30,000<span class="unit">+</span></div>
            <div class="label">设计师与门店</div>
          </div>
          <div class="trust-stat">
            <div class="num">99.9<span class="unit">%</span></div>
            <div class="label">系统可用性</div>
          </div>
          <div class="trust-stat">
            <div class="num">7×24</div>
            <div class="label">专属服务</div>
          </div>
        </div>
        <div class="logo-wall reveal">
          <div class="logo-wall-title">TRUSTED BY LEADING HOME BRANDS</div>
          <div class="logo-grid">
            <div class="logo-item">欧派家居</div>
            <div class="logo-item">索菲亚</div>
            <div class="logo-item">尚品宅配</div>
            <div class="logo-item">顾家家居</div>
            <div class="logo-item">志邦家居</div>
            <div class="logo-item">金牌厨柜</div>
            <div class="logo-item">好莱客</div>
            <div class="logo-item">我乐家居</div>
            <div class="logo-item">全友家居</div>
            <div class="logo-item">曲美家居</div>
            <div class="logo-item">林氏木业</div>
            <div class="logo-item">皮阿诺</div>
          </div>
        </div>
        <div class="trust-cert reveal">
          <div class="cert-card">
            <div class="cert-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg></div>
            <div class="cert-info">
              <div class="title">ISO 27001 信息安全认证</div>
              <div class="desc">国际权威信息安全管理体系认证</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 12l2 2 4-4"/><path d="M3 9h18"/></svg></div>
            <div class="cert-info">
              <div class="title">等保三级认证</div>
              <div class="desc">国家信息安全等级保护三级资质</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/><path d="M2 7l10 5 10-5M12 22V12"/></svg></div>
            <div class="cert-info">
              <div class="title">高新技术企业</div>
              <div class="desc">国家级高新技术企业资质认证</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== FAQ ===== -->
    <section class="section faq-section" id="faq">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">08 FAQ</div>
          <h2 class="section-title">常见问题</h2>
          <p class="section-subtitle">解答用户高频疑问，打消合作顾虑</p>
        </div>
        <div class="faq-wrap reveal">
          <div class="faq-item">
            <div class="faq-q">
              <span>系统是否需要复杂部署？支持免费试用吗？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">本系统为SaaS轻量化模式，无需服务器部署、无需专业运维，开通账号即可使用，平台支持免费试用、预约演示服务。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>能否对接现有设计软件、支付与物流系统？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">系统具备高拓展接口，可无缝对接主流设计平台、支付渠道（微信、支付宝、银联等）、物流快递（顺丰、三通一达等）及主辅材供应链，实现数据互通。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>多门店、多设计师如何设置权限管理？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">支持精细化权限分级，可自定义总部、门店、设计师、员工不同操作权限，适配连锁装企多层级管理需求。支持角色模板、数据隔离、操作日志等企业级管控能力。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>是否提供售后培训和技术支持？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">提供7×24小时技术支持，专属客服一对一服务，配套完整的操作培训、使用教程，全程保驾护航。新客户上线首月提供专属实施顾问免费指导。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>系统收费模式是怎样的？支持升级续费吗？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">采用按需订阅付费模式，无隐形消费，支持套餐升级、续费、功能拓展，适配企业不同发展阶段需求。提供基础版、标准版、旗舰版三档套餐，可根据门店数量和功能需求灵活选择。</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Final CTA ===== -->
    <section class="cta-section" id="cta">
      <div class="container">
        <div class="cta-inner reveal">
          <h2>助力家装家居企业<span class="highlight">数字化转型升级</span></h2>
          <p>设计到交付一体化智慧经营，降本增效、全域增收，开启家装数字化新征程</p>
          <div class="cta-options">
              <a class="btn btn-primary btn-lg" href="#" role="button" @click.prevent="openCustomerService">咨询详情</a>
            </div>
          <div class="cta-note">
            <span>7×24小时技术支持</span>
            <span class="dot"></span>
            <span>一对一专属服务</span>
            <span class="dot"></span>
            <span>免费落地培训指导</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { openCustomerService } from '../../openCustomerService'
defineOptions({ name: 'PortalIsHome' })

let revealIo: IntersectionObserver | null = null

function scrollToSection(id: string) {
  const el = document.getElementById(id)
  if (!el) return
  const scroller = document.querySelector('.portal-page') as HTMLElement | null
  if (scroller) {
    const top =
      el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 12
    scroller.scrollTo({ top, behavior: 'smooth' })
    return
  }
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' })
}

function bindFaq() {
  const rootEl = document.querySelector('.sol-is-home')
  if (!rootEl) return
  rootEl.querySelectorAll('.faq-item').forEach((item) => {
    const q = item.querySelector('.faq-q') as HTMLElement | null
    const a = item.querySelector('.faq-a') as HTMLElement | null
    if (!q || !a) return
    a.style.maxHeight = '0'
    q.onclick = () => {
      const isActive = item.classList.contains('active')
      rootEl.querySelectorAll('.faq-item').forEach((other) => {
        other.classList.remove('active')
        const oa = other.querySelector('.faq-a') as HTMLElement | null
        if (oa) oa.style.maxHeight = '0'
      })
      if (!isActive) {
        item.classList.add('active')
        a.style.maxHeight = a.scrollHeight + 'px'
      }
    }
  })
}

function bindReveal() {
  const nodes = document.querySelectorAll('.sol-is-home .reveal')
  revealIo = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('active')
      })
    },
    { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
  )
  nodes.forEach((n) => revealIo!.observe(n))
}

function bindBars() {
  const bars = document.querySelectorAll('.sol-is-home .bars .bar')
  bars.forEach((bar, i) => {
    const el = bar as HTMLElement
    const h = el.style.height
    if (!h) return
    el.style.height = '0'
    window.setTimeout(() => {
      el.style.transition = `height .8s ease ${i * 0.08}s`
      el.style.height = h
    }, 100)
  })
}

onMounted(() => {
  bindFaq()
  bindReveal()
  bindBars()
})

onBeforeUnmount(() => {
  revealIo?.disconnect()
  revealIo = null
})
</script>

<style lang="scss">

/* ===== Reset & Base ===== */
.sol-is-home,.sol-is-home *,.sol-is-home *::before,.sol-is-home *::after{margin:0;padding:0;box-sizing:border-box}
.sol-is-home{
  --c-primary:#1e88e5;
  --c-primary-2:#1976d2;
  --c-primary-3:#1565c0;
  --c-primary-4:#0d47a1;
  --c-primary-light:#42a5f5;
  --c-primary-bright:#2196f3;
  --c-cyan:#06b6d4;
  --c-slate:#475569;
  --c-slate-light:#64748b;
  --c-text:#0f172a;
  --c-text-mid:#334155;
  --c-bg:#f5f9ff;
  --c-bg-2:#eef4fc;
  --c-bg-3:#e8f1fb;
  --c-border:#e2e8f0;
  --c-white:#fff;
  --c-footer:#0a1929;
  --c-footer-2:#0d2238;
  --radius:14px;
  --radius-lg:22px;
  --shadow-sm:0 2px 8px rgba(30,136,229,.08);
  --shadow:0 8px 28px rgba(30,136,229,.10);
  --shadow-lg:0 18px 56px rgba(30,136,229,.14);
  --shadow-xl:0 28px 80px rgba(30,136,229,.18);
  --shadow-blue:0 10px 30px rgba(30,136,229,.35);
  --max-w:1280px;
  --font:-apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif;
}
.sol-is-home{scroll-behavior:smooth;font-size:16px}
.sol-is-home{font-family:var(--font);color:var(--c-text);background:var(--c-white);line-height:1.7;overflow-x:hidden;-webkit-font-smoothing:antialiased}
.sol-is-home a{text-decoration:none;color:inherit}
.sol-is-home img{max-width:100%;display:block}
.sol-is-home ul{list-style:none}
.sol-is-home .container{max-width:var(--max-w);margin:0 auto;padding:0 24px}
.sol-is-home .section{padding:110px 0;position:relative}
.sol-is-home .section-sm{padding:72px 0}

/* ===== Typography ===== */
.sol-is-home .eyebrow{font-size:.8rem;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--c-primary);margin-bottom:12px}
.sol-is-home .section-num{font-size:.82rem;font-weight:800;letter-spacing:.18em;color:var(--c-primary);display:inline-block;background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));padding:6px 14px;border-radius:100px;margin-bottom:14px}
.sol-is-home .section-title{font-size:2.4rem;font-weight:800;color:var(--c-text);line-height:1.25;margin-bottom:18px;letter-spacing:-.02em}
.sol-is-home .section-subtitle{font-size:1.08rem;color:var(--c-slate);max-width:720px;line-height:1.8}
.sol-is-home .section-head{margin-bottom:64px}
.sol-is-home .section-head.center{text-align:center}
.sol-is-home .section-head.center .section-subtitle{margin:0 auto}
.sol-is-home .section-head.center .section-num{display:inline-block}

/* ===== 3D Buttons ===== */
.sol-is-home .btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:12px 28px;border-radius:12px;font-size:.94rem;font-weight:600;cursor:pointer;border:none;transition:all .25s;white-space:nowrap;line-height:1.2}
.sol-is-home .btn-primary{background:linear-gradient(180deg,#42a5f5 0%,#1e88e5 50%,#1976d2 100%);color:#fff;
  box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 4px 0 var(--c-primary-3),0 8px 20px rgba(30,136,229,.35)}
.sol-is-home .btn-primary:hover{transform:translateY(-2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 6px 0 var(--c-primary-3),0 12px 26px rgba(30,136,229,.45)}
.sol-is-home .btn-primary:active{transform:translateY(2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 1px 0 var(--c-primary-3),0 4px 12px rgba(30,136,229,.35)}
.sol-is-home .btn-outline{background:#fff;color:var(--c-primary-3);border:1.5px solid var(--c-border);box-shadow:0 4px 12px rgba(30,136,229,.08)}
.sol-is-home .btn-outline:hover{border-color:var(--c-primary);color:var(--c-primary);box-shadow:0 6px 18px rgba(30,136,229,.18);transform:translateY(-2px)}
.sol-is-home .btn-ghost{background:rgba(255,255,255,.14);color:#fff;border:1px solid rgba(255,255,255,.35);backdrop-filter:blur(6px)}
.sol-is-home .btn-ghost:hover{background:rgba(255,255,255,.24);transform:translateY(-2px)}
.sol-is-home .btn-lg{padding:17px 40px;font-size:1.05rem;border-radius:14px}
.sol-is-home .btn-lg.btn-primary{box-shadow:inset 0 1px 0 rgba(255,255,255,.45),inset 0 -2px 0 rgba(0,0,0,.1),0 6px 0 var(--c-primary-3),0 12px 28px rgba(30,136,229,.4)}
.sol-is-home .btn-sm{padding:9px 20px;font-size:.85rem;border-radius:10px}

/* ===== Hero (no top nav, reduced top padding) ===== */
.sol-is-home .hero{position:relative;background:linear-gradient(135deg,#0d47a1 0%,#1565c0 30%,#1e88e5 70%,#2196f3 100%);padding:120px 0 100px;overflow:hidden}
.sol-is-home .hero::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background-image:radial-gradient(circle at 15% 40%,rgba(255,255,255,.18) 0%,transparent 45%),radial-gradient(circle at 85% 25%,rgba(66,165,245,.25) 0%,transparent 50%),radial-gradient(circle at 70% 80%,rgba(255,255,255,.1) 0%,transparent 40%);pointer-events:none}
.sol-is-home .hero::after{content:"";position:absolute;bottom:-1px;left:0;right:0;height:80px;background:linear-gradient(to bottom,transparent,var(--c-white));pointer-events:none}
.sol-is-home .hero-grid{display:grid;grid-template-columns:1.1fr .9fr;gap:56px;align-items:center;position:relative;z-index:1}
.sol-is-home .hero-badge{display:inline-flex;align-items:center;gap:10px;padding:8px 18px;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.25);border-radius:100px;color:#fff;font-size:.82rem;font-weight:500;margin-bottom:30px;backdrop-filter:blur(8px)}
.sol-is-home .hero-badge .dot{width:8px;height:8px;background:#34d399;border-radius:50%;box-shadow:0 0 10px #34d399;animation:pulse 1.6s ease-in-out infinite}
@keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.6;transform:scale(1.3)}}
.sol-is-home .hero h1{font-size:3.2rem;font-weight:900;color:#fff;line-height:1.18;letter-spacing:-.025em;margin-bottom:24px}
.sol-is-home .hero h1 .highlight{background:linear-gradient(135deg,#fff,#bbdefb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;position:relative;display:inline-block}
.sol-is-home .hero h1 .highlight::after{content:"";position:absolute;left:0;right:0;bottom:-4px;height:6px;background:linear-gradient(90deg,#fff 0%,rgba(255,255,255,.2) 100%);border-radius:3px;opacity:.5}
.sol-is-home .hero-sub{font-size:1.14rem;color:rgba(255,255,255,.85);line-height:1.85;margin-bottom:28px;max-width:560px}
.sol-is-home .hero-tags{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:36px}
.sol-is-home .hero-tags span{padding:7px 16px;border:1px solid rgba(255,255,255,.3);border-radius:30px;font-size:.8rem;color:rgba(255,255,255,.85);background:rgba(255,255,255,.06);backdrop-filter:blur(4px)}
.sol-is-home .hero-cta{display:flex;gap:16px;margin-bottom:40px;flex-wrap:wrap}
.sol-is-home .hero-trust{display:flex;align-items:center;gap:30px;flex-wrap:wrap}
.sol-is-home .hero-trust-item{display:flex;align-items:center;gap:10px}
.sol-is-home .hero-trust-num{font-size:1.65rem;font-weight:800;color:#fff}
.sol-is-home .hero-trust-label{font-size:.82rem;color:rgba(255,255,255,.6)}
.sol-is-home .hero-trust-divider{width:1px;height:40px;background:rgba(255,255,255,.18)}

/* Hero Dashboard Mockup */
.sol-is-home .hero-visual{position:relative}
.sol-is-home .dash-mock{background:#fff;border-radius:18px;box-shadow:0 40px 90px rgba(0,30,80,.45);overflow:hidden;border:1px solid rgba(255,255,255,.2)}
.sol-is-home .dash-bar{display:flex;align-items:center;gap:8px;padding:14px 18px;background:#f0f7ff;border-bottom:1px solid var(--c-border)}
.sol-is-home .dash-bar .dots{display:flex;gap:6px}
.sol-is-home .dash-bar .dots span{width:10px;height:10px;border-radius:50%}
.sol-is-home .dash-bar .dots span:nth-child(1){background:#ef4444}
.sol-is-home .dash-bar .dots span:nth-child(2){background:#f59e0b}
.sol-is-home .dash-bar .dots span:nth-child(3){background:#22c55e}
.sol-is-home .dash-bar .url{flex:1;text-align:center;font-size:.72rem;color:var(--c-slate-light);background:#fff;border:1px solid var(--c-border);border-radius:6px;padding:4px 14px;margin-left:8px}
.sol-is-home .dash-body{display:grid;grid-template-columns:68px 1fr;min-height:360px}
.sol-is-home .dash-side{background:linear-gradient(180deg,#0d47a1,#1565c0);padding:16px 0;display:flex;flex-direction:column;align-items:center;gap:16px}
.sol-is-home .dash-side .icon-item{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.5);transition:.2s}
.sol-is-home .dash-side .icon-item.active{background:linear-gradient(135deg,#42a5f5,#1e88e5);color:#fff;box-shadow:0 4px 12px rgba(30,136,229,.5)}
.sol-is-home .dash-side .icon-item svg{width:18px;height:18px}
.sol-is-home .dash-main{padding:20px;background:#fafbfc}
.sol-is-home .dash-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px}
.sol-is-home .dash-stat{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:14px;transition:.2s}
.sol-is-home .dash-stat:hover{border-color:var(--c-primary-light);box-shadow:0 4px 12px rgba(30,136,229,.1)}
.sol-is-home .dash-stat-label{font-size:.68rem;color:var(--c-slate-light);margin-bottom:4px}
.sol-is-home .dash-stat-val{font-size:1.2rem;font-weight:800;color:var(--c-text)}
.sol-is-home .dash-stat-trend{font-size:.65rem;font-weight:700;margin-top:3px}
.sol-is-home .up{color:#10b981}
.sol-is-home .dn{color:#ef4444}
.sol-is-home .dash-chart{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:16px}
.sol-is-home .dash-chart-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px}
.sol-is-home .dash-chart-title{font-size:.74rem;font-weight:600;color:var(--c-text)}
.sol-is-home .dash-chart-tag{font-size:.62rem;color:var(--c-primary);background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));padding:3px 10px;border-radius:100px;font-weight:600}
.sol-is-home .bars{display:flex;align-items:flex-end;gap:6px;height:96px}
.sol-is-home .bar{flex:1;border-radius:4px 4px 0 0;background:linear-gradient(180deg,#42a5f5,#1565c0);opacity:.9;transition:opacity .2s}
.sol-is-home .bar:hover{opacity:1}
.sol-is-home .bar.dim{background:linear-gradient(180deg,#cbd5e1,#94a3b8)}
.sol-is-home .dash-float{position:absolute;background:#fff;border-radius:14px;box-shadow:0 14px 36px rgba(0,30,80,.25);padding:14px 18px;display:flex;align-items:center;gap:14px;animation:float 3.5s ease-in-out infinite;border:1px solid rgba(255,255,255,.6)}
.sol-is-home .dash-float-1{top:-20px;right:-12px;animation-delay:0s}
.sol-is-home .dash-float-2{bottom:-18px;left:-18px;animation-delay:1.5s}
.sol-is-home .dash-float-icon{width:42px;height:42px;border-radius:12px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.sol-is-home .dash-float-icon.green{background:linear-gradient(135deg,#d1fae5,#a7f3d0);color:#10b981}
.sol-is-home .dash-float-icon.blue{background:linear-gradient(135deg,#dbeafe,#bfdbfe);color:#1e88e5}
.sol-is-home .dash-float-text .num{font-size:1.05rem;font-weight:800;color:var(--c-text)}
.sol-is-home .dash-float-text .label{font-size:.7rem;color:var(--c-slate-light)}
@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}

/* ===== Pain Points ===== */
.sol-is-home .pain-section{background:linear-gradient(180deg,var(--c-white),var(--c-bg))}
.sol-is-home .pain-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-is-home .pain-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 30px;transition:all .3s;position:relative;overflow:hidden}
.sol-is-home .pain-card:hover{border-color:var(--c-primary-light);box-shadow:var(--shadow-xl);transform:translateY(-6px)}
.sol-is-home .pain-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#1e88e5,#42a5f5,#06b6d4);transform:scaleX(0);transform-origin:left;transition:transform .4s}
.sol-is-home .pain-card:hover::before{transform:scaleX(1)}
.sol-is-home .pain-num{position:absolute;top:24px;right:28px;font-size:2.8rem;font-weight:900;color:rgba(30,136,229,.06);line-height:1}
.sol-is-home .pain-icon{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#e3f2fd,#bbdefb);display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.15)}
.sol-is-home .pain-icon svg{width:28px;height:28px;color:var(--c-primary-2)}
.sol-is-home .pain-title{font-size:1.2rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-is-home .pain-desc{font-size:.92rem;color:var(--c-slate);line-height:1.8}

/* ===== Solution Overview ===== */
.sol-is-home .solution-section{background:#fff}
.sol-is-home .solution-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-is-home .solution-card{background:linear-gradient(145deg,#f5f9ff,#e8f1fb);border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:40px 32px;transition:all .3s;position:relative;overflow:hidden}
.sol-is-home .solution-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px)}
.sol-is-home .solution-card::after{content:"";position:absolute;top:-30px;right:-30px;width:120px;height:120px;background:radial-gradient(circle,rgba(30,136,229,.1),transparent);pointer-events:none}
.sol-is-home .solution-icon{width:52px;height:52px;border-radius:12px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.3)}
.sol-is-home .solution-icon svg{width:26px;height:26px;color:#fff}
.sol-is-home .solution-card h3{font-size:1.25rem;font-weight:700;color:var(--c-text);margin-bottom:14px}
.sol-is-home .solution-card p{font-size:.95rem;color:var(--c-slate);line-height:1.8}

/* ===== Core Functions ===== */
.sol-is-home .func-section{background:linear-gradient(180deg,var(--c-bg),var(--c-white))}
.sol-is-home .func-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:24px}
.sol-is-home .func-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 32px;transition:all .3s;position:relative;overflow:hidden;display:flex;gap:24px}
.sol-is-home .func-card:hover{border-color:var(--c-primary-light);box-shadow:var(--shadow-lg);transform:translateY(-4px)}
.sol-is-home .func-card::before{content:"";position:absolute;left:0;top:0;bottom:0;width:4px;background:linear-gradient(180deg,#1e88e5,#42a5f5);transform:scaleY(0);transform-origin:top;transition:transform .4s}
.sol-is-home .func-card:hover::before{transform:scaleY(1)}
.sol-is-home .func-card-num{font-size:2.4rem;font-weight:900;color:rgba(30,136,229,.12);line-height:1;flex-shrink:0;min-width:56px}
.sol-is-home .func-card-body{flex:1}
.sol-is-home .func-card-icon{width:44px;height:44px;border-radius:11px;background:linear-gradient(135deg,#e3f2fd,#bbdefb);display:flex;align-items:center;justify-content:center;margin-bottom:16px;box-shadow:0 4px 12px rgba(30,136,229,.12)}
.sol-is-home .func-card-icon svg{width:22px;height:22px;color:var(--c-primary-2)}
.sol-is-home .func-card-body h3{font-size:1.2rem;font-weight:700;color:var(--c-text);margin-bottom:10px}
.sol-is-home .func-card-body p{font-size:.92rem;color:var(--c-slate);line-height:1.8}

/* ===== Core Advantages ===== */
.sol-is-home .advantage-section{background:#fff}
.sol-is-home .advantage-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.sol-is-home .advantage-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:34px 28px;transition:all .3s;position:relative;overflow:hidden}
.sol-is-home .advantage-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}
.sol-is-home .advantage-card::before{content:"";position:absolute;bottom:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#1e88e5,#42a5f5);transform:scaleX(0);transform-origin:left;transition:transform .4s}
.sol-is-home .advantage-card:hover::before{transform:scaleX(1)}
.sol-is-home .advantage-icon{width:48px;height:48px;border-radius:12px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin-bottom:20px;box-shadow:0 6px 16px rgba(30,136,229,.25)}
.sol-is-home .advantage-icon svg{width:24px;height:24px;color:#fff}
.sol-is-home .advantage-card h3{font-size:1.12rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-is-home .advantage-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}
.sol-is-home .advantage-card.featured{grid-column:span 3;background:linear-gradient(135deg,#0d47a1,#1565c0);border:none}
.sol-is-home .advantage-card.featured h3{color:#fff}
.sol-is-home .advantage-card.featured p{color:rgba(255,255,255,.75)}
.sol-is-home .advantage-card.featured .advantage-icon{background:rgba(255,255,255,.15);box-shadow:none}
.sol-is-home .advantage-card.featured .advantage-icon svg{color:#90caf9}
.sol-is-home .advantage-card.featured::before{display:none}

/* ===== Application Scenarios ===== */
.sol-is-home .scenario-section{background:linear-gradient(180deg,var(--c-bg),var(--c-bg-2))}
.sol-is-home .scenario-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.sol-is-home .scenario-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:32px 28px;transition:all .3s;position:relative;overflow:hidden}
.sol-is-home .scenario-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}
.sol-is-home .scenario-tag{display:inline-block;padding:5px 12px;background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));color:var(--c-primary);font-size:.72rem;font-weight:700;border-radius:100px;margin-bottom:16px}
.sol-is-home .scenario-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-is-home .scenario-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}
.sol-is-home .scenario-card::after{content:"";position:absolute;bottom:-20px;right:-20px;width:80px;height:80px;background:radial-gradient(circle,rgba(30,136,229,.06),transparent);pointer-events:none}

/* ===== Customer Value ===== */
.sol-is-home .value-section{background:#fff}
.sol-is-home .value-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px}
.sol-is-home .value-card{background:linear-gradient(145deg,#f5f9ff,#e8f1fb);border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 26px;text-align:center;transition:all .3s;position:relative;overflow:hidden}
.sol-is-home .value-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-6px)}
.sol-is-home .value-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#1e88e5,#42a5f5,#06b6d4);transform:scaleX(0);transform-origin:center;transition:transform .4s}
.sol-is-home .value-card:hover::before{transform:scaleX(1)}
.sol-is-home .value-icon{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin:0 auto 20px;box-shadow:0 8px 20px rgba(30,136,229,.3)}
.sol-is-home .value-icon svg{width:28px;height:28px;color:#fff}
.sol-is-home .value-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-is-home .value-card p{font-size:.88rem;color:var(--c-slate);line-height:1.75}
.sol-is-home .value-highlight{display:inline-block;margin-top:14px;padding:5px 14px;background:#fff;border:1px solid var(--c-primary-light);border-radius:100px;font-size:.78rem;font-weight:700;color:var(--c-primary)}

/* ===== Trust Section ===== */
.sol-is-home .trust-section{background:linear-gradient(135deg,#0a3a7a 0%,#0d47a1 50%,#1565c0 100%);position:relative;overflow:hidden;padding:100px 0}
.sol-is-home .trust-section::before{content:"";position:absolute;top:-50%;right:-10%;width:600px;height:600px;background:radial-gradient(circle,rgba(66,165,245,.15) 0%,transparent 70%);pointer-events:none}
.sol-is-home .trust-section::after{content:"";position:absolute;bottom:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.1),transparent)}
.sol-is-home .trust-section .section-title{color:#fff}
.sol-is-home .trust-section .section-subtitle{color:rgba(255,255,255,.7)}
.sol-is-home .trust-section .section-num{color:#90caf9;background:rgba(255,255,255,.1)}
.sol-is-home .trust-stats{display:grid;grid-template-columns:repeat(4,1fr);gap:24px;margin-bottom:60px}
.sol-is-home .trust-stat{text-align:center;padding:36px 22px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);transition:.3s;backdrop-filter:blur(6px)}
.sol-is-home .trust-stat:hover{background:rgba(255,255,255,.08);border-color:rgba(255,255,255,.18);transform:translateY(-6px)}
.sol-is-home .trust-stat .num{font-size:2.8rem;font-weight:900;color:#fff;letter-spacing:-.025em;line-height:1;margin-bottom:8px}
.sol-is-home .trust-stat .num .unit{font-size:1.4rem;font-weight:700}
.sol-is-home .trust-stat .label{font-size:.88rem;color:rgba(255,255,255,.55);font-weight:500}
.sol-is-home .logo-wall{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius-lg);padding:44px;margin-bottom:48px;backdrop-filter:blur(6px)}
.sol-is-home .logo-wall-title{text-align:center;font-size:.82rem;color:rgba(255,255,255,.45);letter-spacing:.18em;text-transform:uppercase;margin-bottom:28px;font-weight:600}
.sol-is-home .logo-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:18px}
.sol-is-home .logo-item{height:64px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:.82rem;font-weight:700;color:rgba(255,255,255,.4);transition:.3s}
.sol-is-home .logo-item:hover{background:rgba(255,255,255,.08);color:rgba(255,255,255,.8);border-color:rgba(255,255,255,.18);transform:translateY(-2px)}
.sol-is-home .trust-cert{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}
.sol-is-home .cert-card{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);padding:28px;display:flex;align-items:center;gap:18px;transition:.3s;backdrop-filter:blur(6px)}
.sol-is-home .cert-card:hover{background:rgba(255,255,255,.08);transform:translateY(-3px)}
.sol-is-home .cert-icon{width:52px;height:52px;border-radius:12px;background:linear-gradient(135deg,rgba(66,165,245,.2),rgba(30,136,229,.2));display:flex;align-items:center;justify-content:center;flex-shrink:0;border:1px solid rgba(66,165,245,.3)}
.sol-is-home .cert-icon svg{width:26px;height:26px;color:#90caf9}
.sol-is-home .cert-info .title{font-size:.92rem;font-weight:700;color:#fff;margin-bottom:4px}
.sol-is-home .cert-info .desc{font-size:.78rem;color:rgba(255,255,255,.45)}

/* ===== FAQ ===== */
.sol-is-home .faq-section{background:linear-gradient(180deg,var(--c-bg),var(--c-white))}
.sol-is-home .faq-wrap{max-width:880px;margin:0 auto}
.sol-is-home .faq-item{border:1.5px solid var(--c-border);border-radius:var(--radius);margin-bottom:14px;overflow:hidden;transition:.3s;background:#fff}
.sol-is-home .faq-item.active{border-color:var(--c-primary);box-shadow:0 8px 28px rgba(30,136,229,.12)}
.sol-is-home .faq-item.active .faq-q{color:var(--c-primary)}
.sol-is-home .faq-q{display:flex;align-items:center;justify-content:space-between;padding:22px 28px;cursor:pointer;font-size:1rem;font-weight:600;color:var(--c-text);transition:color .2s;user-select:none;gap:16px}
.sol-is-home .faq-q .arrow{width:22px;height:22px;flex-shrink:0;transition:transform .3s;color:var(--c-slate-light)}
.sol-is-home .faq-item.active .faq-q .arrow{transform:rotate(180deg);color:var(--c-primary)}
.sol-is-home .faq-a{max-height:0;overflow:hidden;transition:max-height .4s ease}
.sol-is-home .faq-a-inner{padding:0 28px 24px;font-size:.94rem;color:var(--c-slate);line-height:1.85}

/* ===== Final CTA ===== */
.sol-is-home .cta-section{position:relative;background:linear-gradient(135deg,#0d47a1 0%,#1565c0 50%,#1e88e5 100%);padding:100px 0;overflow:hidden}
.sol-is-home .cta-section::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background-image:radial-gradient(circle at 70% 30%,rgba(66,165,245,.25) 0%,transparent 50%),radial-gradient(circle at 20% 80%,rgba(255,255,255,.12) 0%,transparent 40%);pointer-events:none}
.sol-is-home .cta-section::after{content:"";position:absolute;bottom:-1px;left:0;right:0;height:60px;background:linear-gradient(to bottom,transparent,var(--c-footer));pointer-events:none}
.sol-is-home .cta-inner{position:relative;z-index:1;text-align:center;max-width:820px;margin:0 auto}
.sol-is-home .cta-inner h2{font-size:2.5rem;font-weight:900;color:#fff;letter-spacing:-.025em;margin-bottom:20px;line-height:1.25}
.sol-is-home .cta-inner h2 .highlight{background:linear-gradient(135deg,#fff,#bbdefb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.sol-is-home .cta-inner p{font-size:1.12rem;color:rgba(255,255,255,.8);line-height:1.85;margin-bottom:44px}
.sol-is-home .cta-options{display:flex;gap:18px;justify-content:center;flex-wrap:wrap;margin-bottom:36px}
.sol-is-home .cta-note{display:flex;align-items:center;justify-content:center;gap:10px;font-size:.85rem;color:rgba(255,255,255,.5);flex-wrap:wrap}
.sol-is-home .cta-note .dot{width:5px;height:5px;background:rgba(255,255,255,.3);border-radius:50%}

/* ===== Footer (common template text & styles) ===== */
.sol-is-home .footer{background:linear-gradient(180deg,var(--c-footer) 0%,#081422 100%);color:rgba(255,255,255,.55);padding:0;position:relative;overflow:hidden}
.sol-is-home .footer::before{content:"";position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,transparent,var(--c-primary),transparent);opacity:.6}
.sol-is-home .footer-hotline{background:linear-gradient(90deg,#0d2238 0%,#0a1929 100%);padding:28px 0;border-bottom:1px solid rgba(255,255,255,.06)}
.sol-is-home .footer-hotline-inner{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:24px}
.sol-is-home .footer-logo{display:flex;align-items:center;gap:14px}
.sol-is-home .footer-logo-icon{width:52px;height:52px;border-radius:14px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;box-shadow:0 8px 20px rgba(30,136,229,.35)}
.sol-is-home .footer-logo-icon svg{width:30px;height:30px;color:#fff}
.sol-is-home .footer-logo-text{display:flex;flex-direction:column;line-height:1.3}
.sol-is-home .footer-logo-text .name{font-size:1.4rem;font-weight:800;color:#fff;letter-spacing:-.02em}
.sol-is-home .footer-logo-text .url{font-size:.78rem;color:rgba(66,165,245,.7);font-weight:500}
.sol-is-home .footer-hotline-display{display:flex;align-items:center;gap:14px}
.sol-is-home .footer-hotline-label{font-size:1rem;color:rgba(255,255,255,.65);font-weight:500}
.sol-is-home .footer-hotline-num{font-size:2rem;font-weight:900;color:#fff;letter-spacing:.02em;background:linear-gradient(135deg,#42a5f5,#fff);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.sol-is-home .footer-main{padding:56px 0 36px}
.sol-is-home .footer-grid{display:grid;grid-template-columns:1.6fr 1fr 1fr 1.2fr;gap:44px;margin-bottom:44px}
.sol-is-home .footer-brand{display:flex;flex-direction:column;gap:18px}
.sol-is-home .footer-brand-info{display:flex;flex-direction:column;gap:12px;font-size:.85rem;line-height:1.85;color:rgba(255,255,255,.55)}
.sol-is-home .footer-brand-info .row{display:flex;align-items:flex-start;gap:10px}
.sol-is-home .footer-brand-info .row strong{color:rgba(255,255,255,.7);font-weight:600;min-width:78px;flex-shrink:0}
.sol-is-home .footer-badges{display:flex;gap:10px;margin-top:6px}
.sol-is-home .footer-badge{display:inline-flex;align-items:center;justify-content:center;width:42px;height:42px;border-radius:10px;background:linear-gradient(135deg,#dc2626,#b91c1c);color:#fff;font-size:.7rem;font-weight:700;box-shadow:0 4px 10px rgba(220,38,38,.3)}
.sol-is-home .footer-badge.gold{background:linear-gradient(135deg,#f59e0b,#d97706);box-shadow:0 4px 10px rgba(245,158,11,.3)}
.sol-is-home .footer-badge.blue{background:linear-gradient(135deg,#1e88e5,#1565c0);box-shadow:0 4px 10px rgba(30,136,229,.3)}
.sol-is-home .footer-col h4{font-size:1rem;font-weight:700;color:#fff;margin-bottom:20px;letter-spacing:.02em;position:relative;padding-bottom:12px}
.sol-is-home .footer-col h4::after{content:"";position:absolute;left:0;bottom:0;width:24px;height:2px;background:linear-gradient(90deg,#1e88e5,#42a5f5);border-radius:1px}
.sol-is-home .footer-col ul{display:flex;flex-direction:column;gap:11px}
.sol-is-home .footer-col li a{font-size:.88rem;color:rgba(255,255,255,.5);transition:.2s;display:inline-flex;align-items:center;gap:6px}
.sol-is-home .footer-col li a::before{content:"\203A";color:rgba(255,255,255,.3);font-size:1rem;transition:.2s}
.sol-is-home .footer-col li a:hover{color:#42a5f5}
.sol-is-home .footer-col li a:hover::before{color:#42a5f5;transform:translateX(2px)}
.sol-is-home .footer-contact{display:flex;flex-direction:column;gap:18px}
.sol-is-home .footer-contact-row{display:flex;align-items:flex-start;gap:12px;font-size:.88rem}
.sol-is-home .footer-contact-row .ic{width:18px;height:18px;color:#42a5f5;flex-shrink:0;margin-top:2px}
.sol-is-home .footer-contact-row .label{color:rgba(255,255,255,.45);min-width:80px}
.sol-is-home .footer-contact-row .val{color:rgba(255,255,255,.85);font-weight:500}
.sol-is-home .footer-qr{display:flex;gap:18px;margin-top:8px;padding-top:18px;border-top:1px dashed rgba(255,255,255,.08)}
.sol-is-home .footer-qr-item{display:flex;flex-direction:column;align-items:center;gap:8px}
.sol-is-home .footer-qr-img{width:92px;height:92px;background:#fff;border-radius:10px;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden;padding:8px}
.sol-is-home .footer-qr-img::before{content:"";position:absolute;inset:0;background-image:repeating-linear-gradient(0deg,#000 0 4px,transparent 4px 8px),repeating-linear-gradient(90deg,#000 0 4px,transparent 4px 8px);opacity:.85}
.sol-is-home .footer-qr-img::after{content:"RC";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:24px;height:24px;background:linear-gradient(135deg,#1e88e5,#42a5f5);border-radius:6px;display:flex;align-items:center;justify-content:center;color:#fff;font-size:.7rem;font-weight:800;z-index:1;box-shadow:0 0 0 3px #fff}
.sol-is-home .footer-qr-label{font-size:.72rem;color:rgba(255,255,255,.5);text-align:center;line-height:1.5}
.sol-is-home .footer-keywords{display:flex;flex-wrap:wrap;gap:8px;margin-top:14px}
.sol-is-home .footer-kw{padding:4px 10px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.06);border-radius:6px;font-size:.75rem;color:rgba(255,255,255,.5)}
.sol-is-home .footer-bottom{border-top:1px solid rgba(255,255,255,.06);padding:22px 0;background:rgba(0,0,0,.15)}
.sol-is-home .footer-bottom-inner{display:flex;justify-content:space-between;align-items:center;font-size:.82rem;color:rgba(255,255,255,.35);flex-wrap:wrap;gap:12px}
.sol-is-home .footer-bottom a{color:rgba(255,255,255,.35);transition:.2s;margin:0 8px}
.sol-is-home .footer-bottom a:hover{color:#42a5f5}

/* ===== Scroll Animations ===== */
.sol-is-home .reveal{opacity:0;transform:translateY(32px);transition:opacity .8s ease,transform .8s ease}
.sol-is-home .reveal.active{opacity:1;transform:translateY(0)}
.sol-is-home .reveal-delay-1{transition-delay:.12s}
.sol-is-home .reveal-delay-2{transition-delay:.24s}
.sol-is-home .reveal-delay-3{transition-delay:.36s}

/* ===== Mobile Responsive ===== */
@media(max-width:1024px){
  .sol-is-home .hero-grid{grid-template-columns:1fr;gap:48px}
  .sol-is-home .hero h1{font-size:2.6rem}
  .sol-is-home .pain-grid{grid-template-columns:repeat(2,1fr)}
  .sol-is-home .solution-grid{grid-template-columns:1fr}
  .sol-is-home .func-grid{grid-template-columns:1fr}
  .sol-is-home .advantage-grid{grid-template-columns:repeat(2,1fr)}
  .sol-is-home .advantage-card.featured{grid-column:span 2}
  .sol-is-home .scenario-grid{grid-template-columns:repeat(2,1fr)}
  .sol-is-home .value-grid{grid-template-columns:repeat(2,1fr)}
  .sol-is-home .trust-stats{grid-template-columns:repeat(2,1fr)}
  .sol-is-home .logo-grid{grid-template-columns:repeat(3,1fr)}
  .sol-is-home .footer-grid{grid-template-columns:1fr 1fr;gap:36px}
  .sol-is-home .footer-hotline-display{width:100%;justify-content:flex-start}
}
@media(max-width:768px){
  .sol-is-home .section{padding:72px 0}
  .sol-is-home .section-title{font-size:1.8rem}
  .sol-is-home .section-head{margin-bottom:42px}
  .sol-is-home .hero{padding:96px 0 64px}
  .sol-is-home .hero h1{font-size:2.1rem}
  .sol-is-home .hero-sub{font-size:1.05rem}
  .sol-is-home .hero-cta{flex-direction:column;width:100%}
  .sol-is-home .hero-cta .btn{width:100%}
  .sol-is-home .hero-trust{gap:20px}
  .sol-is-home .hero-trust-divider{display:none}
  .sol-is-home .hero-trust-num{font-size:1.4rem}
  .sol-is-home .hero-trust-label{font-size:.78rem}
  .sol-is-home .hero-visual{max-width:440px;margin:0 auto}
  .sol-is-home .dash-float{display:none}
  .sol-is-home .pain-grid{grid-template-columns:1fr;gap:18px}
  .sol-is-home .pain-card{padding:30px 24px}
  .sol-is-home .func-card{padding:28px 24px;flex-direction:column;gap:16px}
  .sol-is-home .func-card-num{font-size:2rem;min-width:auto}
  .sol-is-home .advantage-grid{grid-template-columns:1fr}
  .sol-is-home .advantage-card.featured{grid-column:span 1}
  .sol-is-home .scenario-grid{grid-template-columns:1fr}
  .sol-is-home .value-grid{grid-template-columns:1fr 1fr}
  .sol-is-home .trust-stats{grid-template-columns:1fr 1fr;gap:14px}
  .sol-is-home .trust-stat{padding:24px 14px}
  .sol-is-home .trust-stat .num{font-size:2.1rem}
  .sol-is-home .logo-wall{padding:28px}
  .sol-is-home .logo-grid{grid-template-columns:repeat(2,1fr);gap:14px}
  .sol-is-home .logo-item{height:54px;font-size:.75rem}
  .sol-is-home .trust-cert{grid-template-columns:1fr;gap:14px}
  .sol-is-home .cert-card{padding:20px}
  .sol-is-home .cta-inner h2{font-size:1.9rem}
  .sol-is-home .cta-inner p{font-size:1rem}
  .sol-is-home .cta-options{flex-direction:column;width:100%}
  .sol-is-home .cta-options .btn{width:100%}
  .sol-is-home .footer-hotline-inner{flex-direction:column;align-items:flex-start;text-align:left}
  .sol-is-home .footer-hotline-num{font-size:1.7rem}
  .sol-is-home .footer-grid{grid-template-columns:1fr;gap:32px}
  .sol-is-home .footer-bottom-inner{flex-direction:column;gap:10px;text-align:center}
  .sol-is-home .footer-qr{flex-direction:row;justify-content:flex-start}
}
@media(max-width:480px){
  .sol-is-home .container{padding:0 18px}
  .sol-is-home .hero h1{font-size:1.85rem}
  .sol-is-home .section-title{font-size:1.55rem}
  .sol-is-home .dash-stats{grid-template-columns:1fr;gap:8px}
  .sol-is-home .value-grid{grid-template-columns:1fr}
  .sol-is-home .footer-hotline-num{font-size:1.5rem}
}

/* 业务架构图（参考模版） */
/* 新零售全域业务架构图 */
.sol-is-home .ai-architecture{padding:34px!important;margin-top:46px!important;border:1px solid #d5e6f8!important;border-radius:20px!important;background:#f8fbff!important;box-shadow:0 16px 36px rgba(13,71,161,.08)!important}.ai-architecture h3{font-size:1.48rem!important;color:#102e52!important;text-align:center!important}.ai-architecture>p{max-width:700px;margin:0 auto 28px!important;text-align:center!important;line-height:1.7}.arch-map{display:grid;gap:13px}.arch-band{display:grid;grid-template-columns:174px 1fr;gap:13px;align-items:stretch}.arch-band-label{padding:16px;border-radius:12px;display:flex;flex-direction:column;justify-content:center;background:#e6f1ff;color:#125aa5;font-size:.92rem;font-weight:800}.arch-band-label small{margin-top:5px;color:#5f87b4;font-size:.68rem;font-weight:500}.arch-band-content{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:10px}.arch-unit{min-height:84px;padding:13px 9px;border:1px solid #d4e5f8;border-radius:11px;background:#fff;text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#143b68;font-size:.82rem;font-weight:800;transition:transform .2s,box-shadow .2s}.arch-unit:hover{transform:translateY(-3px);box-shadow:0 7px 16px rgba(30,136,229,.12)}.arch-unit i{display:grid;place-items:center;width:24px;height:24px;margin-bottom:6px;border-radius:7px;background:#e5f1ff;color:#1565c0;font-size:.72rem;font-style:normal}.arch-unit small{display:block;color:#7088a3;font-size:.66rem;font-weight:400;line-height:1.35;margin-top:4px}.arch-band.core .arch-band-label{background:#0d47a1;color:#fff}.arch-band.core .arch-band-label small{color:#c6e1ff}.arch-band.core .arch-unit{background:#1565c0;border-color:#1565c0;color:#fff}.arch-band.core .arch-unit i{background:#fff;color:#1565c0}.arch-band.core .arch-unit small{color:#d6eaff}.arch-band.ai .arch-band-label{background:#e8f3ff}.arch-band.ai .arch-unit{border-color:#b9d9fa;background:#fafdff}.arch-map-note{display:flex;align-items:center;justify-content:center;gap:9px;margin-top:20px;padding-top:16px;border-top:1px dashed #c9ddf2;color:#62809f;font-size:.77rem}.arch-map-note b{color:#1565c0}@media(max-width:1100px){.arch-band-content{grid-template-columns:repeat(3,minmax(0,1fr))}}@media(max-width:700px){.ai-architecture{padding:21px!important}.arch-band{grid-template-columns:1fr}.arch-band-label{padding:12px;align-items:center;text-align:center}.arch-band-content{grid-template-columns:repeat(2,minmax(0,1fr))}.arch-unit{min-height:78px}.arch-map-note{align-items:flex-start;flex-direction:column}}
</style>
